import styled from "styled-components";
import { Upload as AntUpload } from "antd";
import { Typography } from "@atoms";
import { theme } from "@theme";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  flex: 1;
  height: fit-content;
  overflow-x: hidden;
  margin: 32px 0;
  padding: 60px 80px 30px 80px;
  max-width: 1440px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 60px 16px 100px 16px;
    margin: 0;
    gap: 0;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
  }
`;
export const StoryContainer = styled.div`
  display: flex;
  gap: 16px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    gap: 0;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 8px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const PeopleItem = styled(Typography).attrs({ as: "h3" })`
  padding: 10px 18px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background: rgba(240, 229, 222, 0.5);
  }

  &.active {
    background: rgba(240, 229, 222, 1);
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background: #e4d7cd;
`;

export const Upload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  cursor: pointer;
`;

export const UploadParent = styled(AntUpload)`
  .ant-upload-list-text {
    display: none !important;
  }
`;
export const SelectWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

export const ListWrapper = styled.div`
  flex: 1
`
export const TributesWrapper = styled.div`
 flex: 1
`
